import { createLoadingReducer } from './utils';

export default createLoadingReducer('VANDERBILT_SETTINGS');
